import React from "react";

const Header = () => {
  return (
    <header className="header">
      <h1 className="logo">taskit</h1>
    </header>
  )
}

export default Header;